module.exports = __webpack_public_path__ + "static/media/signMob.f0425e9c.svg";